// Charge la base commune
require('./common.js')
